angular.module('AccountingBoxApp')
  .controller('SalesCtrl', function ($scope) {
    $scope.message = 'Hello';
  });
